export default __webpack_public_path__ + "static/media/ViaVarejo.c150aec1.png";